import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import { legalDocs } from "@/data/legal";
import { useLang } from "@/context/LanguageContext";
import { useT } from "@/i18n";

export default function Legal({ docKey }) {
  const { lang } = useLang();
  const t = useT();
  const doc = legalDocs[docKey][lang] || legalDocs[docKey].tr;

  return (
    <div data-testid={`legal-${docKey}-page`}>
      <PageHeader title={doc.title} crumb={doc.title} image="/sections/hero-sanayi.jpg" />

      <section className="py-20 md:py-28 bg-paper">
        <div className="container-kyt max-w-3xl">
          <Reveal>
            <div className="font-mono text-[11px] tracking-[0.16em] uppercase text-slate-400 mb-6">{doc.updated}</div>
            <p className="text-[15.5px] leading-relaxed text-slate-700 font-light">{doc.intro}</p>
          </Reveal>

          <div className="mt-12 space-y-12">
            {doc.sections.map((s, i) => (
              <Reveal key={s.h} delay={i * 50}>
                <div className="border-t border-ink/12 pt-7">
                  <h2 className="font-display text-xl sm:text-2xl font-semibold text-ink">{s.h}</h2>
                  {s.p && s.p.map((para, j) => (
                    <p key={j} className="mt-4 text-[15px] leading-relaxed text-slate-600 font-light">{para}</p>
                  ))}
                  {s.list && (
                    <ul className="mt-4 space-y-2.5">
                      {s.list.map((li) => (
                        <li key={li} className="flex items-start gap-3 text-[15px] leading-relaxed text-slate-600 font-light">
                          <span className="font-mono text-brand-blue text-sm mt-0.5 shrink-0">—</span>
                          <span>{li}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
